// extracted by mini-css-extract-plugin
export default {"cardMvv":"CardMVV_cardMvv__rEZVw","content":"CardMVV_content__W9k9c","cards":"CardMVV_cards__sKUbo"};